import { Grid } from "@material-ui/core/";
import MaterialTable from "material-table";

const TableOnUsers = (props) => {
	const {
		getDataTables,
		fetchAPI,
		BaseUrl,
		tableRef,
		pageSize,
		modalAdd,
		modalEdit,
		state,
	} = props;

	const columns = [
		{ title: "Layanan", field: "layanan" },
		{ title: "Role", field: "role" },
		{ title: "Nama User", field: "nama_user" },
	];

	return (
		<Grid
			item
			direction="column-reverse"
			justifyContent="space-between"
			alignItems="stretch"
		>
			<Grid item>
				<MaterialTable
					title="Users To Role Register"
					tableRef={tableRef}
					columns={columns}
					data={getDataTables({
						url: `${BaseUrl}`,
						state: state,
						type: "userrole",
					})}
					actions={[
						{
							icon: "add_box",
							tooltip: "Add",
							isFreeAction: true,
							onClick: () => modalAdd(),
						},
						() => ({
							icon: "delete",
							tooltip: "Delete",
							iconProps: { style: { fontSize: "20px", color: "red" } },
							onClick: (event, rowData) => {
								fetchAPI("delete", rowData);
							},
						}),
						{
							icon: "edit",
							tooltip: "Edit",
							iconProps: { style: { fontSize: "20px", color: "green" } },
							onClick: (evt, rowData) => modalEdit(rowData),
						},
					]}
					options={{
						actionsColumnIndex: -1,
						paginationType: "stepped",
						pageSize: pageSize,
						pageSizeOptions: [5, 10, 50, 100],
						headerStyle: {
							backgroundColor: "#67A3D5",
							color: "#FFF",
						},
					}}
				/>
			</Grid>
		</Grid>
	);
};

export default TableOnUsers;
